import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn, InputGroup, Label, ActionSection, ScrollableContent, FieldWrappers } from "../Styles/InputStyles";
import Config from "../../Config";
import { MdClose } from "react-icons/md";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FiInfo } from "react-icons/fi";

const GuestReqAccept = ({
    setIsGuestReqAccept,
    selectedData,
    guestReqLoading,
    guestReqMutate,
}) => {
    const onClose = () => {
        setIsGuestReqAccept(false);
    };


    const validateAmount = (value) => {
        if (value === "" || value === null || value === undefined) {
            return;
        }

        if (!/^\d+$/.test(value)) {
            return "Please enter a valid whole number (no decimals)";
        }

        const numValue = parseInt(value, 10);
        if (numValue < 0) {
            return "Amount cannot be negative";
        }
        if (numValue > 100000) {
            return "Amount cannot exceed ₹1,00,000";
        }
    };

    const initialValues = {
        amount: "",
    };

    const handleSubmit = (values, { setSubmitting }) => {
        const amount = values.amount ? parseInt(values.amount, 10) : 0;

        guestReqMutate({
            requestId: selectedData?.id,
            status: Config.REQUEST_STATUS.APPROVED,
            amount: amount,
        });

        setSubmitting(false);
    };

    const isLoading = guestReqLoading;

    return (
        <Container>
            <Header>
                <Title>Approve Guest Request</Title>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>

            <ProfileSection className="flex justify-between">
                <UserInfo>
                    <span className="font-medium mb-0">{selectedData?.tenantName}</span>
                    <span className="text-sm text-gray-600">
                        #{selectedData?.tenantMobile}
                    </span>
                </UserInfo>
            </ProfileSection>

            <Content>
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validateOnChange={true}
                    validateOnBlur={true}
                >
                    {({ isSubmitting, values, setFieldValue, handleBlur, errors }) => (
                        <Form>
                            <ScrollableContent>
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="amount">Charges (₹)</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="number"
                                                id="amount"
                                                name="amount"
                                                placeholder="Enter amount"
                                                className="w-full"
                                                min="0"
                                                max="100000"
                                                step="1"
                                                onBlur={handleBlur}
                                                validate={validateAmount}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value === "" || /^\d+$/.test(value)) {
                                                        const numValue = value === "" ? "" : parseInt(value, 10);
                                                        if (numValue === "" || (numValue >= 0 && numValue <= 100000)) {
                                                            setFieldValue("amount", value);
                                                        } else if (numValue > 100000) {
                                                            setFieldValue("amount", "100000");
                                                        }
                                                    }
                                                }}
                                            />
                                        </FieldWrappers>
                                        <ErrorMessage name="amount">
                                            {(msg) => <ErrorText>{msg}</ErrorText>}
                                        </ErrorMessage>
                                        <NoteText className="flex items-center gap-1">
                                            <FiInfo size={14} />
                                            Charges will be added to the tenant dues.
                                        </NoteText>

                                    </InputGroup>
                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn
                                    type="button"
                                    onClick={onClose}
                                    disabled={isLoading || isSubmitting}
                                >
                                    Back
                                </SideCancelBtn>
                                <SubmitBtn
                                    type="submit"
                                    disabled={isLoading || isSubmitting || errors?.amount}
                                >
                                    {isLoading || isSubmitting ? "Loading..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                        </Form>
                    )}
                </Formik>
            </Content>
        </Container>
    );
};

const Header = tw.div`flex items-center justify-between bg-[#26A69A] py-4 px-4`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const Content = tw.div`p-4 flex flex-col gap-4`;
const Title = tw.h1`text-lg md:text-xl font-medium text-center text-white`;
const UserInfo = tw.div`flex flex-col`;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const NoteText = tw.p`text-sm text-gray-500 mt-2`;
const NoteSubText = tw.p`text-xs text-gray-400 mt-1`;
const ErrorText = tw.p`text-red-400 text-sm mt-1`;

export default GuestReqAccept;